import { type Regles, type Level, Validateur, type Erreur, type Flag } from '@/features/domaine/moteur-regles'
import { shallowRef } from 'vue'

export function useReglesFieldState<TModel extends object, TContext, TLevel extends Level, TFlag extends Flag>(
  regles: Regles<TModel, TContext, TLevel, TFlag>,
) {
  const validateur = new Validateur(regles)
  const state = shallowRef<Erreur<TModel, TLevel>>({})

  let controller: null | AbortController = null
  async function executeAsync(modele: TModel, context: TContext, flag?: TFlag) {
    controller?.abort()
    controller = new AbortController()
    const signal = controller.signal
    const result = await validateur.execute(modele, context, flag)
    if (signal.aborted) {
      return false
    } else {
      state.value = result
      return true
    }
  }

  function $reset() {
    state.value = {
      $estErreur: false,
      $level: null,
      $messageErreur: null,
      $origine: null,
    } as Erreur<TModel, TLevel>
  }

  return { state, executeAsync, $reset }
}

